var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.998047 4.5C0.998047 4.22386 1.2219 4 1.49805 4H18.5006C18.7767 4 19.0006 4.22386 19.0006 4.5C19.0006 4.77614 18.7767 5 18.5006 5H1.49805C1.2219 5 0.998047 4.77614 0.998047 4.5ZM4.57736 10.5C4.57736 10.2239 4.80122 10 5.07736 10H14.9209C15.1971 10 15.4209 10.2239 15.4209 10.5C15.4209 10.7761 15.1971 11 14.9209 11H5.07736C4.80122 11 4.57736 10.7761 4.57736 10.5ZM7.76258 16C7.48644 16 7.26258 16.2239 7.26258 16.5C7.26258 16.7761 7.48644 17 7.76258 17H12.2369C12.5131 17 12.7369 16.7761 12.7369 16.5C12.7369 16.2239 12.5131 16 12.2369 16H7.76258Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.6466cdad5938933f582465b43d4724d8.svg";
export { ForwardRef as ReactComponent };